/**
 * Print Labels
 */

// React
import React, { FC, useEffect, useState } from "react";
import { useLocation } from "react-router";

// Apis
import { GetParcelInventoryItemsRequestBuilder } from "client-sdk/src/parcels/parcels";
import Client from "client-sdk/src/client";

//UI

import { WrapperPrintLabel } from "./style";
import Label from "./components/label";

// Helper
import { flattenObject, useQuery } from "../../utils/helpers";

// Type
import { labelProps } from "./interfaces";
import { Product } from "../parcelLocateInventoryItems/interfaces";

// Style

const PrintLabels: FC<labelProps> = (props: labelProps): React.ReactElement => {
    const [parcelId] = useState<number>(props.match?.params.id!);
    const [items] = useState<string[]>(
        useQuery(useLocation).get("items")?.split(",")!
    );
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        if (items) {
            fetchInventoryItems();
        }
    }, [items]);

    const fetchInventoryItems = async () => {
        try {
            const makeRequest = new GetParcelInventoryItemsRequestBuilder()
                .params(
                    flattenObject({
                        "parcelId.equals": parcelId,
                        "id.in": items.join(","),
                        size: items.length,
                        sort: "sku.product.name,id,asc"
                    })
                )
                .build();
            const client = new Client(localStorage.getItem("token")!);
            const { data } = await client.execute(makeRequest);
            setData(chunk(data.content, 2));
        } catch (error) {
        }
    };

    useEffect(() => {
        if (data) {
            setTimeout(() => {
                window.print();
            }, 500);
        }
    }, [data]);

    const chunk = (arr: any, size: number) => {
        const newArr = [];
        for (let i = 0; i < arr.length; i += 0) {
            const sliced = arr.slice(i, size);
            newArr.push(sliced);
            arr.splice(0, size);
        }
        return newArr;
    };

    return (
        <WrapperPrintLabel>
            {data
                ? data.map((item: Product[], i: number) => (
                    <div key={i} className="page">
                        {item.map((el: Product, i: number) => (
                            <Label nextPage={(i + 1) % 2} data={el} key={i} />
                        ))}
                    </div>
                ))
                : null}
        </WrapperPrintLabel>
    );
};

export default PrintLabels;
